import SearchCustomerStep from "./SearchCustomerStep";
import { CreateCustomerBodyInfo as CreateCustomerBody } from "./SearchCustomerStep";
export default SearchCustomerStep;
export type CreateCustomerBodyInfo = CreateCustomerBody;
